import { Navebar } from "../ui/Navebar";
import { useState } from "react";
import Swal from "sweetalert2";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { uploadFile } from "../../firebase/firebaseConfig";

export const CertificadoManual = () => {
    const [rut, setRut] = useState('');
    const [actividad, setActividad] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [file, setFile] = useState(null);
    const [nombre, setNombre] = useState('');
    const [cargando, setCargando] = useState(false);

    const handleRutText = (event) => {
        setRut(event.target.value);
    }

    const handleActividadText = (event) => {
        setActividad(event.target.value);
    }

    const handleVerificationCodeText = (event) => {
        setVerificationCode(event.target.value);
    }

    const handleFileUpload = (event) => {
        setFile(event.target.files[0]);
    }

    const handleNombreText = (event) => {
        setNombre(event.target.value);
    }

    const validar = () => {
        if (rut === '' || actividad === '' || verificationCode === '' || file === null || nombre === '') {
            Swal.fire('Error', 'Todos los campos son requeridos', 'error');
            return false;
        }
        return true;
    }

    const crearCertificado = async () => {
        if (validar()) {
            try {
                setCargando(true);
                const fileUrl = URL.createObjectURL(file);
                const blob = await fetch(fileUrl).then(res => res.blob());
                console.log(blob);
                const data = {
                    rut,
                    nombre,
                    actividad,
                    qrCode: verificationCode,
                    file: blob,
                    reference: `0-certificados-manual/${rut}/${actividad}/${verificationCode}`
                }
                const response = await uploadFile(data);
                console.log(response);
                Swal.fire('Listo!', 'El certificado se ha creado correctamente', 'success');
                setCargando(false);
            } catch (error) {
                console.log('error:', error.message)
                Swal.fire('Error', 'Ocurrió un problema al crear el certificado', 'error');
            }
        }
    }

    return (
        <>
            <Navebar />
            
            <div className="p-4">
                <h3>Certificado Manual</h3>
                <div className="p-2">
                    <label htmlFor="actividad"> - Añade el nombre de la actividad </label>
                    <input className="mx-2" style={{width:'500px',padding:5}} type="text" onChange={handleActividadText} id="actividad" />
                </div>
                <div className="p-2">
                    <label htmlFor="rut"> - Añade el RUT del participante (con formato xx.xxx.xxx-x)</label>
                    <input className="mx-2" style={{width:'500px',padding:5}} type="text" onChange={handleRutText} id="rut" />
                </div>
                <div className="p-2">
                    <label htmlFor="nombre"> - Añade el nombre del participante </label>
                    <input className="mx-2" style={{width:'500px',padding:5}} type="text" onChange={handleNombreText} id="nombre" />
                </div>
                <div className="p-2">
                    <label htmlFor="verificationCode"> - Añade el código de verificación </label>
                    <input className="mx-2" style={{width:'500px',padding:5}} type="text" onChange={handleVerificationCodeText} id="verificationCode" />
                </div>
                <div className="p-2">
                    <label htmlFor="file"> - Selecciona el archivo que contiene el certificado: </label>
                    <input className="mx-2" type="file" accept="application/pdf, image/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={handleFileUpload} id="file" />
                </div>

                <div className="p-2">
                    <button className="btn btn-primary" onClick={crearCertificado}>Crear Certificado</button>
                </div>
            </div>
        </>
        
    )
};
